<template>
    <form-wizard
        ref="wizard"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{ 'hidden-navigation': navigationHidden }"
        :color="color"
        :error-color="errorColor"
        :title="localTitle"
        :subtitle="localSubtitle"
        @on-complete="formSubmitted"
        @on-change="onChange"
        shape="circle"
    >
        <tab-content
            v-for="(step, index) in flatSteps"
            ref="tabs"
            :key="index"
            :title="step.name"
            :icon="step.icon"
            class="mb-5 content"
            :before-change="() => runValidator(index)"
        >
            <component
                :ref="`tab${index}`"
                :is="step.component"
                :step="step"
                :form="value"
                v-bind="step.props"
                :navigation-hidden.sync="navigationHidden"
            ></component>
        </tab-content>
    </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
    name: 'vx-dynamic-form',
    components: {
        FormWizard,
        TabContent
    },
    props: {
        steps: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'rgba(var(--vs-primary), 1)'
        },
        errorColor: {
            type: String,
            default: 'rgba(var(--vs-danger), 1)'
        }
    },
    watch: {
        flatSteps() {
            var i = this.activeStep + 1
            var tabs = this.$refs.tabs

            while (tabs[i]) {
                tabs[i].checked = false
                i++
            }
        }
    },
    data() {
        return {
            activeStep: 0,
            navigationHidden: false
        }
    },
    computed: {
        flatSteps() {
            var flatsteps = []

            const search = (currentStep) => {
                if (!currentStep) {
                    return
                }

                flatsteps.push(currentStep)

                if (Array.isArray(currentStep.next)) {
                    currentStep.next.forEach((step) => {
                        search(step)
                    })
                } else {
                    search(currentStep.next)
                }
            }

            this.steps.forEach((step) => search(step))
            return flatsteps
        },
        currentTab() {
            return this.getTab(this.activeStep)
        },
        currentStep() {
            return this.getStep(this.activeStep)
        },
        localTitle() {
            if (this.currentStep && this.currentStep.title) {
                return this.currentStep.title
            }
            return this.title
        },
        localSubtitle() {
            if (this.currentStep && this.currentStep.subtitle) {
                return this.currentStep.subtitle
            }
            return this.subtitle
        }
    },
    methods: {
        async runValidator(index) {
            var comp = this.$refs[`tab${index}`][0]
            var validation_result = true

            if (comp.validate && typeof comp.validate === 'function') {
                validation_result = comp.validate()
                if (validation_result.then) {
                    validation_result = await validation_result
                }
            }

            var vvalidate_result = await comp.$validator.validate()

            return validation_result && vvalidate_result
        },
        onChange(prevIndex, nextIndex) {
            this.activeStep = nextIndex
            this.$emit('on-change', prevIndex, nextIndex)
        },
        getTab(index) {
            if (this.$refs.tabs) {
                return this.$refs.tabs[index]
            }
            return null
        },
        getStep(index) {
            return this.flatSteps[this.activeStep] || null
        },
        formSubmitted() {
            var immutableResult = this.deepCopy(this.value)
            this.reset()
            this.$emit('form-completed', immutableResult)
        },
        reset() {
            this.$refs.wizard.reset()
        },
        activateAll() {
            this.$refs.wizard.activateAll()
        }
    }
}
</script>

<style scoped>
.content {
    min-height: 150px;
}
.hidden-navigation ::v-deep .wizard-card-footer {
    pointer-events: none;
    opacity: 0;
}
</style>
